import {
  GET_DROPZZ,
  GET_DROPZZ_ITEM,
  SET_DROPZZ_PAGE,
  SET_DROPZZ_LIST_TYPE,
} from '../../shared/constants/ActionTypes';

const initialState = {
  items: [],
  total: 0,
  page: 1,
  listType: 'all',
  currentItem: null,
};

const dropzzReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DROPZZ:
      return {
        ...state,
        items: action.payload.data,
        total: action.payload.total,
      };
    case GET_DROPZZ_ITEM:
      return {
        ...state,
        currentItem: action.payload,
      };
    case SET_DROPZZ_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_DROPZZ_LIST_TYPE:
      return {
        ...state,
        listType: action.payload,
        page: 1,
      };
    default:
      return state;
  }
};

export default dropzzReducer;
